import { FC } from 'react';

import { LIVE_CHAT_TEST_IDS } from '../../lib/testIds';
import { Dot1, Dot2, Dot3, DotWrapper } from './LoadingIndicator.styles';

const Dots = () => (
  <DotWrapper data-testid={LIVE_CHAT_TEST_IDS.LOADING_INDICATOR}>
    <Dot1 />
    <Dot2 />
    <Dot3 />
  </DotWrapper>
);

Dots.displayName = 'Dots';

export const LoadingIndicator: FC = () => <Dots />;

LoadingIndicator.displayName = 'LoadingIndicator';
